import { RESERVED_PREFILL_QUERY_KEYS } from "./constants/prefill";

export const validatePrefillQueryKey = ({ queryKeys, queryKey }) => {
  let error = null;
  if (!queryKey || !Array.isArray(queryKeys)) {
    return error;
  }

  const duplicateKey = queryKeys.indexOf(queryKey) > -1;
  const noWhitespace = /^\S*$/.test(queryKey);
  if (RESERVED_PREFILL_QUERY_KEYS[queryKey]) {
    error = "Key is reserved";
  } else if (duplicateKey) {
    error = "Key already exists";
  } else if (!noWhitespace) {
    error = "Spaces not allowed";
  }
  return error;
};

export const validatePrefillQueryKeys = (queryKeys) => {
  let error = null;
  if (!Array.isArray(queryKeys) || !queryKeys.length) {
    error = "Minimum of one key is required";
  }

  return error;
};
